<div class="school-detail" *ngIf="config$ | async as config">
  <div class="school-detail__contact bg-base-grey-light">
    <div class="school-detail__header">
      <h3 class="school-detail__title text-base-blue-light">{{ config.school.site_escola.tipo }}</h3>
      <span class="school-detail__name text-base-secondary">{{ config.school.site_escola.titulo }}</span>
    </div>

    <a [href]="locationMap(config.school)" target="_blank" class="school-detail__map text-base-blue-light">
      <svg class="school-detail__icon" viewBox="0 0 16 16">
        <path
          clip-rule="evenodd"
          d="M2 6V6.29266C2 7.72154 2.4863 9.10788 3.37892 10.2236L8 16L12.6211 10.2236C13.5137 9.10788 14 7.72154 14 6.29266V6C14 2.68629 11.3137 0 8 0C4.68629 0 2 2.68629 2 6ZM8 8C9.10457 8 10 7.10457 10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8Z"
          fill="currentColor"
          fill-rule="evenodd"
        ></path>
      </svg>
      <div>
        <div>{{ config.school?.endereco }}</div>
        <div>{{ config.school?.cidade }} - {{ config.school?.uf }}</div>
        <div *ngIf="!!config.school.cep">
          {{ 'connections.cep' | translate }}:
          {{ config.school.cep | mask: config.plugin.handler.home.applyPostalCodeMask(config.school.cep) }}
        </div>
      </div>
    </a>

    <a
      [href]="locationMap(config.school)"
      target="_blank"
      class="pl-16 school-detail__link text-base-secondary text-start"
    >
      {{ 'contact.view-map' | translate }}
    </a>

    <div class="pl-16 school-detail__group-phone text-base-blue">
      <a [href]="phoneLink(config.school)" target="_blank" class="school-detail__phone">
        {{ 'connections.telephone' | translate }}:
        {{ config.school.telefone | mask: config.plugin.handler.home.applyPhoneMask(config.school.telefone) }}
      </a>
      <a
        [href]="whatsLink(config.school)"
        target="_blank"
        *ngIf="!!config.school.whatsapp"
        class="school-detail__phone"
      >
        {{ 'connections.whatsapp' | translate }}:
        {{ config.school.whatsapp | mask: config.plugin.handler.home.applyPhoneMask(config.school.whatsapp) }}
      </a>
    </div>

    <div *ngIf="config.school.site_escola" class="px-16 school-detail__group-actions">
      <button
        *ngIf="!!config.school.site_escola.atendimento_online"
        class="text-white school-detail__action bg-base-blue-light hover:bg-base-blue hover:text-base-grey-light"
        type="button"
        (click)="onSchedule()"
      >
        {{ 'contact.schedule-service' | translate }}
      </button>
      <a
        *ngIf="!!config.school.site_escola.whatsapp"
        [href]="whatsLink(config.school)"
        target="_blank"
        class="school-detail__action bg-base-blue text-base-font-secondary hover:bg-base-font-primary hover:text-base-secondary"
      >
        {{ 'contact.whatsapp-support' | translate }}
      </a>
      <ng-container *ngIf="enrolment$ | async as enrolment">
        <ng-container *ngIf="!!enrolment.data; else runnableTemplate">
          <a class="school-detail__action school-detail__action--highlight" [href]="enrolment.data" target="_blank">
            {{ 'contact.online-enrollment' | translate }}
          </a>
        </ng-container>
        <ng-template #runnableTemplate>
          <a class="school-detail__action school-detail__action--highlight" (click)="onSchedule()">
            {{ 'contact.online-enrollment' | translate }}
          </a>
        </ng-template>
      </ng-container>
    </div>
  </div>

  <div class="school-detail__facade-container">
    <ng-container *ngIf="facade$ | async as facade; else elseTemplate">
      <img
        class="school-detail__facade"
        src-fallback="assets/images/fachada.webp"
        trackingLoad
        [alt]="'global.facade' | translate"
        [src]="facade"
      />
    </ng-container>
    <ng-template #elseTemplate>
      <img
        class="school-detail__facade"
        trackingLoad
        [alt]="'global.facade' | translate"
        src="assets/images/fachada.webp"
      />
    </ng-template>
  </div>
</div>
